<template>
  <formWrapper :validator="$v.form">
    <v-form @submit.prevent="handleSubmit">
      <v-container>
        <v-row>
          <v-col cols="6">
            <form-group name="reason" attribute="fields.reason">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  :label="$t('fields.reason')"
                  v-bind="attrs"
                  v-on="listeners"
                  outlined
                  dense
                  v-model="form.reason"
                ></v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col cols=" 4">
            <form-group name="value" attribute="fields.value">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  :label="$t('fields.value')"
                  type="number"
                  v-bind="attrs"
                  v-on="listeners"
                  outlined
                  dense
                  v-model="form.value"
                ></v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col cols="2">
            <v-btn
              :disabled="$v.form.$invalid"
              :loading="loading"
              class="primary"
              block
              type="submit"
            >
              {{ $t("button.add") }}
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </formWrapper>
</template>

<script>
import { StoreData } from "@/helpers/apiMethods";
import {
  maxValue,
  minLength,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
export default {
  name: "FormActions",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: () => ({ sub_total: "" })
    }
  },
  data() {
    return {
      loading: false,

      form: {
        reason: "",
        value: ""
      }
    };
  },
  methods: {
    resetData() {
      for (const key in this.form) {
        this.form[key] = "";
      }
      this.$v.form.$reset();
    },

    handleSubmit() {
      this.loading = true;

      StoreData({
        reqName: `car-rent-orders/${this.order.reference_number}/over-prices`,
        data: this.form
      })
        .then(res => {
          const { over_price } = res.data;
          this.resetData();
          this.$emit("on-submit", over_price);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  validations() {
    return {
      form: {
        reason: {
          minLength: minLength(2),
          maxLength: maxLength(50)
        },
        value: {
          maxValue: maxValue(this.order.sub_total),
          numeric
        }
      }
    };
  }
};
</script>
